import type { TApiResponse, TApiResponseType } from '@/types/api-types/TApiResponse'
import DigestateJobsApiUrls from './endpoints'
import BaseApiRequest from '../BaseApiRequest'
import type {
  TGetDigestateJobsParams,
  IDigestateJobsApi,
  TGetDigestateJobByIdParams,
  TUpdateDigestateJobParams,
  TUpdateDigestateJobByIdRequestBody,
  TDeleteDigestateJobParams,
  TCreateDigestateJobRequestBody
} from '@/types/api-types/digestateJob'
import type { IBulkOperationResponseType } from '@/types/api-types/IApiResponse'
import type { TItemRequestQueryParams } from '@/types/api-types'

class DigestateJobsApiRequest extends BaseApiRequest implements IDigestateJobsApi {
  async getDigestateJobs(params: TGetDigestateJobsParams): TApiResponse {
    return this.get(DigestateJobsApiUrls.DIGESTATE_JOBS(), params)
  }

  async getDigestateJobById(params: TGetDigestateJobByIdParams): TApiResponse {
    const { id, ...rest } = params
    const url = `${DigestateJobsApiUrls.DIGESTATE_JOBS_BY_ID(id)}`
    return this.get(url, rest)
  }

  async updateDigestateJob(
    params: TUpdateDigestateJobParams,
    requestBody: TUpdateDigestateJobByIdRequestBody
  ): TApiResponse {
    const { id, ...rest } = params
    const url = `${DigestateJobsApiUrls.DIGESTATE_JOBS_BY_ID(id)}`
    return this.put(url, requestBody, rest)
  }

  async deleteDigestateJob(
    params?: TDeleteDigestateJobParams
  ): TApiResponseType<IBulkOperationResponseType> {
    return this.delete(DigestateJobsApiUrls.DIGESTATE_JOBS(), params)
  }

  async createDigestateJob(requestBody: TCreateDigestateJobRequestBody, params?: TItemRequestQueryParams): TApiResponse {
    return this.post(DigestateJobsApiUrls.DIGESTATE_JOBS(), requestBody, params)
  }
}

export default DigestateJobsApiRequest
